/** Every Twitch VOD is kept at least this long. Copy is the earliest it may disappear. */
export const VOD_EARLIEST_RETENTION_DAYS = 7;

/**
 * Affiliate minimum, once `broadcaster_type` is stored at VOD sync.
 * Not read today. Turbo and Prime are not visible through the API.
 */
export const VOD_AFFILIATE_RETENTION_DAYS = 14;

const MAY_EXPIRE_WINDOW_DAYS = 3;
const DAY_MS = 24 * 60 * 60 * 1000;

export type VodExpiryLabel =
  | { kind: 'unavailable' }
  | { kind: 'may_expire'; text: string }
  | { kind: 'none' };

/** Hook for a future stored broadcaster type. Always the 7-day floor until then. */
export function vodEarliestRetentionDays(_broadcasterType?: string | null): number {
  return VOD_EARLIEST_RETENTION_DAYS;
}

export function vodExpiryLabel(
  vodCreatedAt: string | null | undefined,
  playbackStatus: string | null | undefined,
  now: Date
): VodExpiryLabel {
  if ((playbackStatus ?? '').trim().toLowerCase() === 'unavailable') {
    return { kind: 'unavailable' };
  }
  if (!vodCreatedAt) {
    return { kind: 'none' };
  }
  const created = Date.parse(vodCreatedAt);
  if (Number.isNaN(created)) {
    return { kind: 'none' };
  }
  const earliest = created + vodEarliestRetentionDays() * DAY_MS;
  const remainingMs = earliest - now.getTime();
  if (remainingMs < 0) {
    return { kind: 'none' };
  }
  const remainingDays = Math.ceil(remainingMs / DAY_MS);
  if (remainingDays > MAY_EXPIRE_WINDOW_DAYS) {
    return { kind: 'none' };
  }
  if (remainingDays <= 0) {
    return { kind: 'may_expire', text: 'May expire today' };
  }
  if (remainingDays === 1) {
    return { kind: 'may_expire', text: 'May expire tomorrow' };
  }
  return { kind: 'may_expire', text: `May expire in ${remainingDays} days` };
}
